import React from "react";
import ReportProfileTableRow from "./ReportProfileTableRow";

interface ReportProfile {
  reportId: number;
  code: string;
  name: string;
  enabled: boolean;
}

interface ReportProfileTableBodyProps {
  reports: ReportProfile[];
  onToggle: (report: ReportProfile) => void; // ✅ pasa el objeto completo
}

/**
 * 🧩 Cuerpo de la tabla de reportes
 *
 * - Compatible con el modelo `IProfileReport` del backend (usa `id`).
 * - Mantiene el mismo diseño visual, clases y coherencia de estilos.
 */
const ReportProfileTableBody: React.FC<ReportProfileTableBodyProps> = ({
  reports,
  onToggle,
}) => {
  if (!reports.length) {
    return (
      <tbody>
        <tr>
          <td
            colSpan={4}
            className="text-center py-6 text-gray-500 dark:text-gray-400"
          >
            No hay reportes configurados para este perfil.
          </td>
        </tr>
      </tbody>
    );
  }

  return (
    <tbody>
      {reports.map((report, index) => (
        <ReportProfileTableRow
          key={report.reportId}
          index={index}
          report={report}
          onToggle={onToggle} // ✅ pasa el report completo
        />
      ))}
    </tbody>
  );
};

export default ReportProfileTableBody;
